export const TERMS_OF_USE = 'https://www.procursys.com/terms-of-use';
export const PRIVACY_POLICY = 'https://www.procursys.com/privacy-policy';
export const DEFAULT_TITLE = 'Procursys';
